import NavItems from "./NavItems"
import HeaderLogo from "./components/HeaderLogo";
import "./Header.css"
import ramadanImg from "../../assets/ramadan/DecorationBackground.jpg"
import { currentMonth } from "../ramadan"

export default function Header() {

  return (
    <header className={`py-0 bg-light-gray position-relative z-3 ${currentMonth === 9 ? 'bgOpacity10' : ''}`}>
      <div className="container-md d-flex">
        <HeaderLogo />
        <NavItems />
      </div>
      <img src={ramadanImg} alt="ramadan" className="ramadan-img" />
    </header>

  );
}
